import { DirectiveType } from '../../types';
import { AbstractMultiValueDirective } from '../abstract-multi-value-directive';
export class WorkerSource extends AbstractMultiValueDirective {
    getDirectiveName() {
        return 'worker-src';
    }
    getDirectiveType() {
        return DirectiveType.Fetch;
    }
    getMinimumCspVersion() {
        return 3;
    }
}
